import { render, staticRenderFns } from "./TabbedContent.vue?vue&type=template&id=1cf08ce1&"
import script from "./TabbedContent.vue?vue&type=script&lang=js&"
export * from "./TabbedContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports